export default __webpack_public_path__ + "static/business-analyst-e6c338cc8da56747ececdc65b6bdf586.jpg";